(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-receiver.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-receiver.js');
"use strict";


const {
  useOrderHomeContext
} = svs.ticketsOrderHome.context;
const {
  ReactSymbols: Symbols
} = svs.ui;
const {
  SearchForm,
  SearchResult
} = svs.ticketsOrderHome.orderHome.receiver.components;
const SearchReceiver = () => {
  const {
    state: {
      receiver
    }
  } = useOrderHomeContext();
  return React.createElement("div", {
    className: "order-home-receiver-body margin-top-3 f-body"
  }, receiver.result ? React.createElement(SearchResult, null) : React.createElement(SearchForm, null), React.createElement("p", {
    className: "f-content f-400 fw-500 u-text-center w100 margin-0 margin-top-half"
  }, "Lotterna skickas direkt efter betalning och \xE4r framme inom n\xE5gra dagar."), React.createElement("p", {
    className: "f-content disclaimer w100 margin-top-1 margin-bottom-2"
  }, React.createElement("span", {
    className: "padding-top-1"
  }, "Mottagaren m\xE5ste ha fyllt 18 \xE5r."), React.createElement("span", null, React.createElement(Symbols, {
    className: "logo-18 margin-left-1 absolute",
    height: 56,
    name: "18-logo-pos"
  }))));
};
setGlobal('svs.ticketsOrderHome.orderHome.receiver.components.SearchReceiver', SearchReceiver);

 })(window);